import { SxProps } from '@mui/system';

export const headerStyles: SxProps = {
	width: '75%',
};
